module.exports = __webpack_public_path__ + "static/media/logo.cba436e6.png";